import { types } from "mobx-state-tree";
export const StampModel = types
    .model("Stamp", {
    url: types.string,
    width: types.number,
    height: types.number
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhbXAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvcGx1Z2lucy9kcmF3aW5nL21vZGVsL3N0YW1wLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBWSxLQUFLLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUVsRCxNQUFNLENBQUMsTUFBTSxVQUFVLEdBQUcsS0FBSztLQUM1QixLQUFLLENBQUMsT0FBTyxFQUFFO0lBQ2QsR0FBRyxFQUFFLEtBQUssQ0FBQyxNQUFNO0lBQ2pCLEtBQUssRUFBRSxLQUFLLENBQUMsTUFBTTtJQUNuQixNQUFNLEVBQUUsS0FBSyxDQUFDLE1BQU07Q0FDckIsQ0FBQyxDQUFDIn0=